// Form de creación de Lead Magnet. Envía POST /api/v1/lead-magnets.

import { useState } from 'react';

import { useCreateLeadMagnet } from '../hooks/useLeadMagnets';
import type { LeadMagnetType } from '../types';

interface Props {
  onCreated?: () => void;
}

export function LeadMagnetForm({ onCreated }: Props) {
  const [slug, setSlug] = useState('');
  const [title, setTitle] = useState('');
  const [type, setType] = useState<LeadMagnetType>('pdf');
  const [description, setDescription] = useState('');
  const [gatedAssetUrl, setGatedAssetUrl] = useState('');
  const [headline, setHeadline] = useState('');
  const { submit, loading, error } = useCreateLeadMagnet();
  const [success, setSuccess] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSuccess(null);
    const res = await submit({
      slug: slug.trim().toLowerCase(),
      title: title.trim(),
      type,
      description: description.trim(),
      gated_asset_url: gatedAssetUrl.trim(),
      landing_headline: headline.trim(),
    });
    if (res) {
      setSuccess(`Magnet "${res.slug}" creado — landing: ${res.public_url}`);
      setSlug('');
      setTitle('');
      setDescription('');
      setGatedAssetUrl('');
      setHeadline('');
      onCreated?.();
    }
  };

  return (
    <form onSubmit={onSubmit} className="space-y-3 p-4 border rounded-md max-w-2xl">
      <h3 className="text-base font-semibold">Nuevo Lead Magnet</h3>

      <div className="grid grid-cols-2 gap-3">
        <label className="block">
          <span className="text-xs text-muted-foreground">Slug (URL)</span>
          <input
            type="text"
            required
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
            placeholder="checklist-personal-brand"
            className="mt-1 w-full border rounded px-2 py-1 text-sm font-mono"
          />
        </label>

        <label className="block">
          <span className="text-xs text-muted-foreground">Tipo</span>
          <select
            value={type}
            onChange={(e) => setType(e.target.value as LeadMagnetType)}
            className="mt-1 w-full border rounded px-2 py-1 text-sm"
          >
            <option value="pdf">PDF descargable</option>
            <option value="checklist">Checklist</option>
            <option value="quiz">Quiz interactivo</option>
            <option value="email-course">Mini email-course</option>
          </select>
        </label>
      </div>

      <label className="block">
        <span className="text-xs text-muted-foreground">Título</span>
        <input
          type="text"
          required
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Checklist · convertir Reddit en MRR"
          className="mt-1 w-full border rounded px-2 py-1 text-sm"
        />
      </label>

      <label className="block">
        <span className="text-xs text-muted-foreground">Headline (opcional)</span>
        <input
          type="text"
          value={headline}
          onChange={(e) => setHeadline(e.target.value)}
          placeholder="Tienes la audiencia. ¿Tienes el funnel?"
          className="mt-1 w-full border rounded px-2 py-1 text-sm"
        />
      </label>

      <label className="block">
        <span className="text-xs text-muted-foreground">Descripción / promesa</span>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={3}
          className="mt-1 w-full border rounded px-2 py-1 text-sm"
        />
      </label>

      <label className="block">
        <span className="text-xs text-muted-foreground">URL del recurso (PDF/quiz)</span>
        <input
          type="url"
          value={gatedAssetUrl}
          onChange={(e) => setGatedAssetUrl(e.target.value)}
          placeholder="https://cdn.example.com/asset.pdf"
          className="mt-1 w-full border rounded px-2 py-1 text-sm"
        />
      </label>

      {error && <div className="text-sm text-destructive">{error}</div>}
      {success && <div className="text-sm text-primary">{success}</div>}

      <button
        type="submit"
        disabled={loading}
        className="px-4 py-2 text-sm rounded bg-primary text-primary-foreground disabled:opacity-50"
      >
        {loading ? 'Creando…' : 'Crear Lead Magnet'}
      </button>
    </form>
  );
}
